<script setup lang="ts">
  import {
    createLocation,
    type CreateLocalLocation,
    type CreateLocationErrors,
  } from '@/model/location.model.ts'
  import { useLocationStore } from '@/store/location.store.ts'
  import type { Organization } from '@/types/organization'
  import { DropDown, FormInput } from '@logistiek-zonder-papier/lzp-library'
  import { storeToRefs } from 'pinia'
  import { onMounted } from 'vue'

  const { organization } = defineProps<{
    organization: Organization
    errors: CreateLocationErrors
  }>()

  const locationStore = useLocationStore()
  const { locationCategories, locationTypes } = storeToRefs(locationStore)
  const locationData = defineModel<Partial<CreateLocalLocation>>({ required: true })
  // TODO this is dumb and needs to be emitted
  locationData.value = createLocation(organization.organisatieUUID)

  onMounted(locationStore.fetchLocationCategories)
</script>

<template>
  <FormInput
    v-model="locationData.naam"
    label="Naam"
    placeholder="Vul naam in"
    :error="errors.naam"
    :data-validation-error="!!errors.naam"
  />

  <FormInput
    v-model="locationData.vestigingsNummer"
    label="Vestigingsnummer"
    placeholder="Vul vestigingsnummer in"
    :optional="true"
    :error="errors.vestigingsNummer"
    :data-validation-error="!!errors.vestigingsNummer"
  />

  <FormInput
    v-model="locationData.straatnaam"
    label="Straatnaam"
    placeholder="Vul straatnaam in"
    :error="errors.straatnaam"
    :data-validation-error="!!errors.straatnaam"
  />

  <FormInput
    v-model="locationData.huisNummer"
    label="Huisnummer"
    placeholder="Vul huisnummer in"
    type="number"
    optional
    :error="errors.huisNummer"
    :data-validation-error="!!errors.huisNummer"
  />

  <FormInput
    v-model="locationData.toevoeging"
    label="Toevoeging"
    placeholder="Toevoeging"
    optional
    :error="errors.toevoeging"
    :data-validation-error="!!errors.toevoeging"
  />

  <FormInput
    v-model="locationData.stad"
    label="Stad"
    placeholder="Vul stad in"
    :error="errors.stad"
    :data-validation-error="!!errors.stad"
  />

  <FormInput
    v-model="locationData.postcode"
    label="Postcode"
    placeholder="Vul postcode in"
    :error="errors.postcode"
    :data-validation-error="!!errors.postcode"
  />

  <FormInput
    v-model="locationData.land"
    label="Land"
    placeholder="Vul land in"
    :error="errors.land"
    :data-validation-error="!!errors.land"
  />

  <DropDown
    v-model="locationData.locatieCategory"
    label="Locatie categorie"
    :data="locationCategories"
    :error="errors.locatieCategory"
    :data-validation-error="!!errors.locatieCategory"
    required
  >
    <template #empty>Selecteer locatie categorie</template>
    <template #item="{ item }">{{ item['category'] }}</template>
  </DropDown>
  <DropDown
    v-model="locationData.locatieType"
    :data="locationTypes"
    label="Locatie type"
    :error="errors.locatieType"
    :data-validation-error="!!errors.locatieType"
    required
  >
    <template #empty>Selecteer locatie type</template>
    <template #item="{ item }">{{ item['value'] }}</template>
  </DropDown>
</template>

<style scoped></style>
